<template>
  <v-layout column align-center class="links">
    <v-layout class="content" row>
      <v-btn flat dark router-link :to="{name: 'PatientsPage'}">{{$t('label.patients')}}</v-btn>
      <v-spacer></v-spacer>
      <!-- <v-btn outline color="white" router :to="{name: 'ProvidersPage'}">Request Records</v-btn> -->
    </v-layout>
  </v-layout>
</template>

<style lang="scss" scoped>
@import "../../styles/variables";

.links {
  background: $primaryColor;
  width: 100%;

  .content {
    width: 100%;
    max-width: 1024px;
  }
}

.links .btn {
  text-transform: capitalize;
}
</style>


<script>
export default {
  name: 'UiHeaderLinks'
}
</script>



// WEBPACK FOOTER //
// src/components/headers/DesktopHeaderLinks.vue